import { render, staticRenderFns } from "./TheMobileSidebar.vue?vue&type=template&id=22b9f154&scoped=true&"
import script from "./TheMobileSidebar.vue?vue&type=script&lang=js&"
export * from "./TheMobileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheMobileSidebar.vue?vue&type=style&index=0&id=22b9f154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9f154",
  null
  
)

export default component.exports